/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Url_Bacnet_ExclusiveInputs */



/**
* | output |
* | --- |
* | "IP and Bacnet Device ID are mutually exclusive" |
*
* @param {Module_Add_Url_Bacnet_ExclusiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_url_bacnet_exclusive = /** @type {((inputs?: Module_Add_Url_Bacnet_ExclusiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Url_Bacnet_ExclusiveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("IP and Bacnet Device ID are mutually exclusive")
	return /** @type {LocalizedString} */ ("IP et Device Bacnet ID sont mutuellement exclusifs")
});